import { useState } from 'react';
import { Link } from 'react-router-dom';

interface NavigationProps {
  scrolled: boolean;
  bannerVisible?: boolean;
}

export default function Navigation({ scrolled, bannerVisible = false }: NavigationProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { label: 'Features', to: '/features', isRoute: true },
    { label: 'Pricing', to: '/pricing', isRoute: true },
    { label: 'For CFIs', to: '/for-cfis', isRoute: true },
    { label: 'Safety', to: '/for-cfis', isRoute: false },
    { label: 'Download', to: '#download', isRoute: false },
    { label: 'Join Waitlist', to: '/waitlist', isRoute: true },
  ];

  return (
    <nav
      className={`fixed left-0 right-0 z-50 transition-all duration-300 ${
        bannerVisible ? 'top-[38px]' : 'top-0'
      } ${
        scrolled || menuOpen ? 'bg-[#0A1628]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      } border-b border-[#00FFD1]/20`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img
            src="https://public.readdy.ai/ai/img_res/2de32bf8-6894-4f4a-ba90-b9480aaa88cf.png"
            alt="WingmanFix Logo"
            className="h-10 w-10 object-contain"
          />
          <span className="text-xl font-bold tracking-tight">WingmanFix</span>
        </div>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) =>
            link.isRoute ? (
              <Link
                key={link.label}
                to={link.to}
                className="text-sm text-gray-300 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.to}
                className="text-sm text-gray-300 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            )
          )}
        </div>

        {/* Hamburger Button */}
        <button
          className="md:hidden flex flex-col justify-center items-center w-9 h-9 gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          <span
            className={`block h-0.5 w-6 bg-[#00FFD1] transition-all duration-300 ${
              menuOpen ? 'rotate-45 translate-y-2' : ''
            }`}
          />
          <span
            className={`block h-0.5 w-6 bg-[#00FFD1] transition-all duration-300 ${
              menuOpen ? 'opacity-0' : ''
            }`}
          />
          <span
            className={`block h-0.5 w-6 bg-[#00FFD1] transition-all duration-300 ${
              menuOpen ? '-rotate-45 -translate-y-2' : ''
            }`}
          />
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        } bg-[#0A1628]/98 border-t border-[#00FFD1]/10`}
      >
        <div className="flex flex-col px-6 py-4 gap-5">
          {navLinks.map((link) =>
            link.isRoute ? (
              <Link
                key={link.label}
                to={link.to}
                onClick={() => setMenuOpen(false)}
                className="text-sm text-gray-300 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.to}
                onClick={() => setMenuOpen(false)}
                className="text-sm text-gray-300 hover:text-[#00FFD1] transition-colors uppercase tracking-wider cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            )
          )}
        </div>
      </div>
    </nav>
  );
}
